function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  stroke: "#3D3234",
  d: "M61.533.5C42.101.5 33.6 2.142 24.792 6.852c-7.736 4.137-13.803 10.204-17.94 17.94C2.142 33.599.5 42.102.5 61.533v720.934c0 19.432 1.642 27.934 6.352 36.741 4.137 7.736 10.204 13.803 17.94 17.94 8.807 4.71 17.31 6.352 36.741 6.352h283.934c19.432 0 27.934-1.642 36.741-6.352 7.736-4.137 13.803-10.204 17.94-17.94 4.71-8.807 6.352-17.31 6.352-36.741V61.533c0-19.432-1.642-27.934-6.352-36.741-4.137-7.736-10.204-13.803-17.94-17.94C373.401 2.142 364.898.5 345.467.5H61.533z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M67.278 16h272.444c17.83 0 24.296 1.857 30.815 5.343 6.518 3.486 11.634 8.602 15.12 15.12C389.143 42.982 391 49.447 391 67.278v709.444c0 17.83-1.857 24.296-5.343 30.815-3.486 6.518-8.602 11.634-15.12 15.12-6.519 3.486-12.984 5.343-30.815 5.343H67.278c-17.83 0-24.296-1.857-30.815-5.343-6.518-3.486-11.634-8.602-15.12-15.12C17.857 801.018 16 794.553 16 776.722V67.278c0-17.83 1.857-24.296 5.343-30.815 3.486-6.518 8.602-11.634 15.12-15.12C42.982 17.857 49.447 16 67.278 16z"
}), React.createElement("path", {
  fill: "#EFECF6",
  stroke: "#E2E0EB",
  d: "M41.5 647.5H127c6.351 0 11.5-5.149 11.5-11.5v-18c0-6.351-5.149-11.5-11.5-11.5H53c-6.351 0-11.5 5.149-11.5 11.5v29.5z"
}), React.createElement("text", {
  fill: "#000",
  fontFamily: "SFProText-Regular, SF Pro Text",
  fontSize: 15,
  transform: "translate(41 606)"
}, React.createElement("tspan", {
  x: 16,
  y: 25
}, "\u041F\u0440\u0438\u0432\u0435\u0442!")), React.createElement("g", {
  transform: "translate(41 746)"
}, React.createElement("path", {
  fill: "#EFECF6",
  stroke: "#E2E0EB",
  d: "M.5 41.5H52c6.351 0 11.5-5.149 11.5-11.5V12C63.5 5.649 58.351.5 52 .5H12C5.649.5.5 5.649.5 12v29.5z"
}), React.createElement("circle", {
  cx: 20,
  cy: 21,
  r: 4,
  fill: "#C8C3DC"
}), React.createElement("circle", {
  cx: 32,
  cy: 21,
  r: 4,
  fill: "#C8C3DC"
}), React.createElement("circle", {
  cx: 44,
  cy: 21,
  r: 4,
  fill: "#C8C3DC"
})), React.createElement("path", {
  fill: "#EFECF6",
  stroke: "#E2E0EB",
  d: "M41.5 656.5v81H275c6.351 0 11.5-5.149 11.5-11.5v-58c0-6.351-5.149-11.5-11.5-11.5H41.5z"
}), React.createElement("text", {
  fill: "#000",
  fontFamily: "SFProText-Regular, SF Pro Text",
  fontSize: 15,
  transform: "translate(41 656)"
}, React.createElement("tspan", {
  x: 16,
  y: 25
}, "\u041C\u0435\u043D\u044F \u0437\u043E\u0432\u0443\u0442 \u0411\u0430\u0437\u043E\u043D \u2014 \u0441\u0430\u043C\u0430\u044F "), React.createElement("tspan", {
  x: 16,
  y: 45
}, "\u0431\u044B\u0441\u0442\u0440\u0430\u044F \u043B\u0430\u043F\u0430 \u0432 \u043C\u0438\u0440\u0435 "), React.createElement("tspan", {
  x: 16,
  y: 65
}, "\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u0442\u043E\u043A\u0430")), React.createElement("g", {
  fill: "#000"
}, React.createElement("path", {
  fillOpacity: 0.38,
  d: "M354.5 33.5h17A2.5 2.5 0 0 1 374 36v6.5a2.5 2.5 0 0 1-2.5 2.5h-17a2.5 2.5 0 0 1-2.5-2.5V36a2.5 2.5 0 0 1 2.5-2.5zm0 1h17A1.5 1.5 0 0 1 373 36v6.5a1.5 1.5 0 0 1-1.5 1.5h-17a1.5 1.5 0 0 1-1.5-1.5V36a1.5 1.5 0 0 1 1.5-1.5zm20.5 2.334a2.499 2.499 0 0 1 0 4.332v-4.332z"
}), React.createElement("path", {
  d: "M355 35.5h16a1 1 0 0 1 1 1V42a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1v-5.5a1 1 0 0 1 1-1z"
})), React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M339.479 44.105h-.228l-2.029-2.032a.162.162 0 0 1 .021-.247 3.69 3.69 0 0 1 2.138-.678 3.69 3.69 0 0 1 2.118.665.162.162 0 0 1 .022.247l-2.042 2.045zm4.714-4.97l.01.237-1.222 1.225-.215.012a5.403 5.403 0 0 0-3.385-1.185 5.404 5.404 0 0 0-3.402 1.2l-.216-.013-1.222-1.224.01-.238a7.438 7.438 0 0 1 4.83-1.772c1.773 0 3.466.621 4.812 1.757zm2.673-2.671l.006.235-1.219 1.221-.22.008a9.152 9.152 0 0 0-6.052-2.276c-2.25 0-4.391.813-6.069 2.29l-.22-.007-1.22-1.221.007-.235a11.187 11.187 0 0 1 7.502-2.874c2.78 0 5.425 1.016 7.485 2.859z"
}), React.createElement("path", {
  fill: "#000",
  d: "M310.5 40.5h1a1 1 0 0 1 1 1v1.75a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V41.5a1 1 0 0 1 1-1zm4.75-2h1a1 1 0 0 1 1 1v3.75a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V39.5a1 1 0 0 1 1-1zM320 36h1a1 1 0 0 1 1 1v6.25a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V37a1 1 0 0 1 1-1zm4.75-2.25h1a1 1 0 0 1 1 1v8.5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-8.5a1 1 0 0 1 1-1z"
}), React.createElement("path", {
  d: "M77.5 31h16v16h-16z"
}), React.createElement("path", {
  stroke: "#000",
  d: "M86.455 43.086l3.084-7.125-7.125 3.084h4.041v4.041z"
}), React.createElement("text", {
  fill: "#000",
  fontFamily: "SFProText-Semibold, SF Pro Text",
  fontSize: 15,
  fontWeight: 500,
  letterSpacing: -0.24,
  transform: "translate(37 29)"
}, React.createElement("tspan", {
  x: 0.724,
  y: 14
}, "12:22")), React.createElement("path", {
  fill: "#282324",
  d: "M104 16h199v6c0 13.255-10.745 24-24 24H128c-13.255 0-24-10.745-24-24v-6z"
}));

var SvgPhoneWithChat = function SvgPhoneWithChat(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 407,
    height: 844,
    viewBox: "0 0 407 844",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPhoneWithChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PhoneWithChat.1806ebf7.svg";
export { ForwardRef as ReactComponent };